module.exports = __webpack_public_path__ + "static/img/team.4154c5ac.png";